"use client";

import DemoForm from "../landing-page/DemoFrom";
import VideoSection from "../landing-page/VideoSection";

export default function Hero() {
  return (
    <div className="py-8 md:py-12 bg-white">
      <div className="max-w-6xl mx-auto px-4">

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-center">

          {/* Form Section */}
          <div>
            <DemoForm />
          </div>

          {/* Video Section */}
          <div>
            <VideoSection />
          </div>

        </div>
      </div>
    </div>
  );
}
